// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__NkvdO","alertIcon":"ConfirmModal_alertIcon__2HTdu"};